import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { formatTargetRate, formatThreshold } from '@/shared/lib/utils';
import { StatTile } from '@/shared/ui';

type Props = {
  /** Всего диалогов в выборке */
  totalDialogs: number;
  /** Доля цели по всей выборке (0..1) или null */
  baselineRate: number | null;
  /** Текущий порог близости */
  threshold: number;
  /** Число кластеров текущего среза */
  clusters: number;
};

/**
 * Строка KPI «Иерархии понятий»: объём выборки, базовая доля цели по всей
 * выборке (как в матрице), текущий порог и число кластеров.
 */
export const HierarchyKpi: FC<Props> = ({ totalDialogs, baselineRate, threshold, clusters }) => {
  const { t } = useTranslation('strategist');

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
      <StatTile label={t('hierarchy.kpi.totalDialogs')}>{totalDialogs.toLocaleString()}</StatTile>
      <StatTile label={t('hierarchy.kpi.baseline')}>{formatTargetRate(baselineRate)}</StatTile>
      <StatTile label={t('hierarchy.kpi.threshold')}>{formatThreshold(threshold)}</StatTile>
      <StatTile label={t('hierarchy.kpi.clusters')}>{clusters.toLocaleString()}</StatTile>
    </div>
  );
};
